import React from 'react';

const PageTitle = ({children}) => {
    return(
        <div id='pagetitle' className={'titleWrapper'}>
            <div className={'titleContainer'}>
                <h2>
                    {children}
                </h2>
            </div>
        </div>
    );
};

export default PageTitle;